import { Component, OnInit } from '@angular/core';
import { MapService } from 'src/app/services/map.service';
import {getPointResolution, get as getProjection} from 'ol/proj';
import olMap from 'ol/Map';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { EventListenersOnMap } from 'src/app/utils/eventListenersOnMap';
import { IdentifyToolService } from 'src/app/services/identify-tool.service';
import { SelectByFirComponent } from 'src/app/popup/select-by-fir/select-by-fir.component';
import { TerrainTypeModel } from 'src/app/models/terrains';
import { TerrainHeightService } from '../services/terrain-height.service';
import { TerrainAltitudeCutService } from 'src/app/services/terrain-altitude-cut.service';
import { AzimuthToolService } from '../services/azimuth-tool.service';
import { DistanceAzimuthComponent } from '../distance-azimuth/distance-azimuth.component';
import { DistanceAzimuthService } from '../services/distance-azimuth.service';

@Component({
  selector: 'app-scale-control',
  templateUrl: './scale-control.component.html',
  styleUrls: ['./scale-control.component.scss'],
  standalone: false
})
export class ScaleControlComponent implements OnInit {

  scale : number = 10000;
  map: olMap;

  constructor(private mapService : MapService, public toolsService : ToolsControlService,) {
    this.map = this.mapService.getMap('map');
   }

  ngOnInit(): void {
    this.setScale()
  }


  setScale() : void {
    const scale = this.scale;
    const resolution = 25.4 / 0.28;;
    const viewResolution = this.map.getView().getResolution();
    const scaleResolution =
      scale /
      getPointResolution(
        this.map.getView().getProjection(),
        resolution / 25.4,
        this.map.getView().getCenter()
      );
    this.map.getView().setResolution(scaleResolution);
  }

  displayCloseEventsButton(): boolean {
    return (
      EventListenersOnMap.hasEvent(IdentifyToolService.EVENT_ON_MAP_LABEL) ||
      EventListenersOnMap.hasEvent(SelectByFirComponent.EVENT_ON_MAP_LABEL) ||
      EventListenersOnMap.hasEvent(TerrainHeightService.EVENT_ON_MAP_LABEL) ||
      EventListenersOnMap.hasEvent(DistanceAzimuthService.EVENT_ON_MAP_LABEL)||
      EventListenersOnMap.hasEvent(TerrainAltitudeCutService.EVENT_ON_MAP_LABEL)
    );
  }
}
